import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, FormControl } from '@angular/forms';
import { AlertController, NavController, LoadingController, ToastController } from '@ionic/angular';

import { Salon, Currency } from '../../../models';
import { UserService } from '../../../services/user.service';
import { SalonService } from '../../../services/salon.service';
import { CurrencyService } from '../../../services/currency.service';
import { Utilities } from '../../../utilities/utilities';
import { List } from 'immutable';
import { Router } from '@angular/router';
@Component({
  selector: 'app-currency',
  templateUrl: './currency.page.html',
  styleUrls: ['./currency.page.scss'],
})
export class CurrencyPage implements OnInit {

  public salon: Salon;

  public isLoading: boolean;

  public errorOccured: boolean;

  public currencyPicker;

  public currencyForm: UntypedFormGroup;

  public currencies: List<Currency>;

  constructor (private navCtrl: NavController,
               private userService: UserService,
               private salonService: SalonService,
               private formBuilder: UntypedFormBuilder,
               private alertController: AlertController,
               private loadingCtrl: LoadingController,
               private toastController: ToastController,
               private currencyService: CurrencyService,
               private ref: ChangeDetectorRef,
               private router: Router
  ) {
    this.salon = this.userService.getSalon();
    this.currencyPicker = parseInt(this.salon.getCurrencyID());

    this.currencies=  List([]);
  }


  public ngOnInit () {
    this.loadCurrencies();
  }

  public loadCurrencies () {
    this.isLoading = true;
    this.errorOccured = false;
    this.currencyService.getCurrencies()
      .subscribe({next:(currencies) => {
          this.currencies = currencies;
          this.isLoading = false;
          this.ref.detectChanges();

        },
        error:(err) => {
          this.isLoading = false;
          this.errorOccured = true;
          this.ref.detectChanges();
        }});
  }

  public async save () {

    const loader = await this.loadingCtrl.create({spinner: 'crescent'});
    loader.present();

    const currencyID: number = this.currencyPicker;
    const selectedCurrency: Currency = this.currencies.filter((c) => c.id === currencyID).toList().first();
    let symbol: string = '';

    if (selectedCurrency) {
      symbol = selectedCurrency.symbol;
    }

    this.salon = this.salon.setCurrencyID(currencyID+ '');
    this.salon = this.salon.setCurrency(symbol);

    this.salonService.saveSalon(this.salon)
      .subscribe({next: (salon: Salon) => {
          this.salon = salon;
          this.userService.setSalon(this.salon);
          loader.dismiss().then(() => {
            this.router.navigateByUrl('/settings/pos-settings').then(async () => {
              const toast = await this.toastController.create({
                message: `Salon's currency has been updated`,
                duration: 3000
              })
              toast.present();
            });
          });
        },
        error: (err) => {
          loader.dismiss().then(async () => {
            const alert = await this.alertController.create(Utilities.getDefaultErrorMessageConfig())
            alert.present();
          });
        }});
  }

}
